import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash'

import {
  Table,
  Button,
  Row,
  Grid,
  Col,
  Image,
  Panel,
  ButtonGroup,
  FormGroup,
  FormControl,
  ControlLabel,
  Jumbotron,
  Label,
  Alert,
  ToggleButtonGroup,
  ToggleButton,
  Checkbox
} from 'react-bootstrap';

import TableAna from '../../statics/images_annamnese/img_ana.jpg'

import '../../statics/css/user-detail.css'
import '../../statics/css/util.css'
import '../../statics/css/anamnese.css'

import { saveAnamneseToUser } from '../../dao-firebase/user-firebase'

class Anamnese extends Component {

  constructor(props) {
    super(props);

    this.state = {

      load: false,

      //User
      user: undefined,

      //qs        
      q1: "",
      q2: "",
      q3: "",
      q4: "",
      q5: "",
      q6: "",
      q7: {},
      q8: "",
      q9: "",
      q10: "",
      q11: "",
      q12: "",
      q13: "",
      q14: "",
      q15: "",
      q16: "",
      q17: "",
      q18: "",
      q19: "",


    };

    //refs
    //this.anamnese_wakeup_hour_ref = React.createRef();

  }

  componentDidMount() {


  }

  componentWillMount() {

    let userToLoad = undefined;

    console.log(this.props.location)

    if (this.props.user) {

      userToLoad = this.props.user

    } else {

      userToLoad = this.props.location.state.user;
      userToLoad.id = userToLoad.uid;

    }

    this.setState({
      user: userToLoad,
    }, () => {
      //atribuindo valores

      if (this.state.user && this.state.user.data && this.state.user.data.anamnese2) {
        this.setState({
          q1: this.state.user.data.anamnese2.q1,
          q2: this.state.user.data.anamnese2.q2,
          q3: this.state.user.data.anamnese2.q3,
          q4: this.state.user.data.anamnese2.q4,
          q5: this.state.user.data.anamnese2.q5,
          q6: this.state.user.data.anamnese2.q6,
          q7: !this.state.user.data.anamnese2.q7 ? {} : this.state.user.data.anamnese2.q7,
          q8: this.state.user.data.anamnese2.q8,
          q9: this.state.user.data.anamnese2.q9,
          q10: this.state.user.data.anamnese2.q10,
          q11: this.state.user.data.anamnese2.q11,
          q12: this.state.user.data.anamnese2.q12,
          q13: this.state.user.data.anamnese2.q13,
          q14: this.state.user.data.anamnese2.q14,
          q15: this.state.user.data.anamnese2.q15,
          q16: this.state.user.data.anamnese2.q16,
          q17: this.state.user.data.anamnese2.q17,
          q18: this.state.user.data.anamnese2.q18,
          q19: this.state.user.data.anamnese2.q19,
        })
      }
    })

  }

  onInputChange(target) {

    console.log(target);

    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  changeItemQ7(e, indexItem) {

    console.log("EVENT: ", e)
    this.state.q7[indexItem] = e.target.checked
    console.log("CHECKED: ", e.target.checked)
    this.setState({
      q7: this.state.q7,
    })

  }

  saveAnamnese() {

    this.setState({
      load: true,
      loadUser: true,
    })

    let anamnese2 = {
      q1: this.state.q1,
      q2: this.state.q2,
      q3: this.state.q3,
      q4: this.state.q4,
      q5: this.state.q5,
      q6: this.state.q6,
      q7: this.state.q7,
      q8: this.state.q8,
      q9: this.state.q9,
      q10: this.state.q10,
      q11: this.state.q11,
      q12: this.state.q12,
      q13: this.state.q13,
      q14: this.state.q14,
      q15: this.state.q15,
      q16: this.state.q16,
      q17: this.state.q17,
      q18: this.state.q18,
      q19: this.state.q19,
    }

    //Verifica-se se o usuário logado é professor
    if (JSON.parse(localStorage.getItem("USER")).role == 'professor') {
      this.props.handleSaveAnamnese(anamnese2);
    } else {
      //Logado é aluno
      this.userSaveAnamnese(anamnese2);
    }

  }

  renderMessage(message) {
    return (
      <p>
        <strong>{message.substring(0, message.indexOf(" "))}</strong>
        {message.substring(message.indexOf(" "))}
      </p>
    )
  }

  userSaveAnamnese(anamnese) {

    console.log(this.state.user.data)

    saveAnamneseToUser(this.state.user.data.professor_code, this.state.user, anamnese, (response, success) => {

      if (success) {

        this.state.user.data.anamnese = anamnese;
        localStorage.setItem("USER", JSON.stringify(this.state.user))

        this.setState({

          messageUser: "Anamnese atualizada com sucesso!",
          messageUserStatus: "success",
          updateComponenentAnamnese: !this.state.updateComponenentAnamnese,
          load: false,
          loadUser: false,
        })


        //Trazendo scroll pra 0 pra garantir a visibilidade da mensagem
        window.scrollTo(0, 0);

        setTimeout(() => {
          if (this.state.messageAll == "Anamnese atualizada com sucesso!") {

            this.setState({
              messageAll: '',
            });

          }
        }, 5000);

      } else {
        this.setState({

          messageUser: "Falha ao atualizar Anamnese!",
          messageUserStatus: "danger",
          load: false,
          loadUser: false,
        })

        //Trazendo scroll pra 0 pra garantir a visibilidade da mensagem
        window.scrollTo(0, 0);
      }
    })
  }

  render() {

    return (

      <div className="anamnese-page">

        {this.state.messageUser && this.state.messageUser != '' ?
          <Alert bsStyle={!this.state.messageUserStatus || this.state.messageUserStatus == '' ? 'warning' : this.state.messageUserStatus}>
            {this.renderMessage(this.state.messageUser)}
          </Alert>
          : null}

        {
          //verificando se é professor
          JSON.parse(localStorage.getItem("USER")).role == 'professor' ?
            null
            :
            <div>
              <h1>Olá, <span className="color-primary">{this.state.user && this.state.user.data ? this.state.user.data.name : null}</span></h1>
              <br />
              <p>Preencha as informações abaixo.</p>
              <br />
            </div>
        }

        {/* Q1 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>1. Profissão e Horário de Trabalho</ControlLabel>
          <FormControl
            name="q1"
            type="text"
            componentClass="textarea"
            rows="4"
            className="textarea-fixed"
            value={this.state.q1}
            onChange={(event) => this.onInputChange(event.target)}
          />
        </FormGroup>

        {/* Q2 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>2. Horários de Estudos / Escola / Faculdade</ControlLabel>
          <FormControl
            name="q2"
            type="text"
            componentClass="textarea"
            rows="4"
            className="textarea-fixed"
            value={this.state.q2}
            onChange={(event) => this.onInputChange(event.target)}
          />
        </FormGroup>

        {/* Q3 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>3. Pratica exercícios físicos? Há quanto tempo pratica e há quanto tempo treina sem dar uma pausa?</ControlLabel>
          <FormControl
            name="q3"
            type="text"
            componentClass="textarea"
            rows="4"
            className="textarea-fixed"
            value={this.state.q3}
            onChange={(event) => this.onInputChange(event.target)}
          />
        </FormGroup>

        {/* Q4 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>4. Qual exercício físico você faz: (Conte tudo sobre seu treino, como é seu treino, séries, repetições, tempo, e o que achar necessário).</ControlLabel>
          <FormControl
            name="q4"
            type="text"
            componentClass="textarea"
            rows="4"
            className="textarea-fixed"
            value={this.state.q4}
            onChange={(event) => this.onInputChange(event.target)}
          />
        </FormGroup>

        {/* Q5 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>5. Fale um pouco do que almeja com o exercício? Qual seu objetivo?</ControlLabel>
          <FormControl
            name="q5"
            type="text"
            componentClass="textarea"
            rows="4"
            className="textarea-fixed"
            value={this.state.q5}
            onChange={(event) => this.onInputChange(event.target)}
          />
        </FormGroup>

        {/* Q6 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>6. Quanto ao esforço em seus treinos, marque o número que mais se adequa a sua realidade?</ControlLabel>
          <Image src={TableAna} responsive />

          <ControlLabel>Resposta</ControlLabel>
          <FormControl
            name="q6"
            type="text"
            componentClass="textarea"
            rows="4"
            className="textarea-fixed"
            value={this.state.q6}
            onChange={(event) => this.onInputChange(event.target)}
          />
        </FormGroup>

        {/* Q7 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>7. Marque as máquinas/aparelhos que não tem na sua academia:</ControlLabel>
          <FormGroup>
            <Checkbox checked={this.state.q7[1]} onChange={(e) => this.changeItemQ7(e, 1)}>Agachamento livre barra</Checkbox>
            <Checkbox checked={this.state.q7[2]} onChange={(e) => this.changeItemQ7(e, 2)}>Agachamento guiado (Smith)</Checkbox>
            <Checkbox checked={this.state.q7[3]} onChange={(e) => this.changeItemQ7(e, 3)}>Gravinton</Checkbox>
            <Checkbox checked={this.state.q7[4]} onChange={(e) => this.changeItemQ7(e, 4)}>Cadeira extensora</Checkbox>
            <Checkbox checked={this.state.q7[5]} onChange={(e) => this.changeItemQ7(e, 5)}>Mesa flexora</Checkbox>
            <Checkbox checked={this.state.q7[6]} onChange={(e) => this.changeItemQ7(e, 6)}>Cadeira flexora</Checkbox>
            <Checkbox checked={this.state.q7[7]} onChange={(e) => this.changeItemQ7(e, 7)}>Cadeira abdutora</Checkbox>
            <Checkbox checked={this.state.q7[8]} onChange={(e) => this.changeItemQ7(e, 8)}>Cadeira adutora</Checkbox>
            <Checkbox checked={this.state.q7[9]} onChange={(e) => this.changeItemQ7(e, 9)}>Caixote</Checkbox>
            <Checkbox checked={this.state.q7[10]} onChange={(e) => this.changeItemQ7(e, 10)}>Step</Checkbox>
            <Checkbox checked={this.state.q7[11]} onChange={(e) => this.changeItemQ7(e, 11)}>Bola Suíça</Checkbox>
            <Checkbox checked={this.state.q7[12]} onChange={(e) => this.changeItemQ7(e, 12)}>Caneleira</Checkbox>
            <Checkbox checked={this.state.q7[13]} onChange={(e) => this.changeItemQ7(e, 13)}>Banco supino reto</Checkbox>
            <Checkbox checked={this.state.q7[14]} onChange={(e) => this.changeItemQ7(e, 14)}>Banco supino reto (Máquina)</Checkbox>
            <Checkbox checked={this.state.q7[15]} onChange={(e) => this.changeItemQ7(e, 15)}>Banco supino inclinado </Checkbox>
            <Checkbox checked={this.state.q7[16]} onChange={(e) => this.changeItemQ7(e, 16)}>Banco supino inclinado (Máquina)</Checkbox>
            <Checkbox checked={this.state.q7[17]} onChange={(e) => this.changeItemQ7(e, 17)}>Barras livres</Checkbox>
            <Checkbox checked={this.state.q7[18]} onChange={(e) => this.changeItemQ7(e, 18)}>Barras montadas</Checkbox>
            <Checkbox checked={this.state.q7[19]} onChange={(e) => this.changeItemQ7(e, 19)}>Halteres</Checkbox>
            <Checkbox checked={this.state.q7[20]} onChange={(e) => this.changeItemQ7(e, 20)}>Kettlebell </Checkbox>
          </FormGroup>
        </FormGroup>

        {/* Q8 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>8. Faz uso de alguma substâncias? (Cigarro, álcool, café, qualquer remédio e etc)</ControlLabel>
          <FormControl
            name="q8"
            type="text"
            componentClass="textarea"
            rows="4"
            className="textarea-fixed"
            value={this.state.q8}
            onChange={(event) => this.onInputChange(event.target)}
          />
        </FormGroup>

        {/* Q9 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>9. Sofre com alguma doença? Já sofreu alguma lesão? Já fez alguma cirurgia? Tem alguma limitação óssea/muscular? Tem algum desconforto em algum exercício? Conte-me tudo:</ControlLabel>
          <FormControl
            name="q9"
            type="text"
            componentClass="textarea"
            rows="4"
            className="textarea-fixed"
            value={this.state.q9}
            onChange={(event) => this.onInputChange(event.target)}
          />
        </FormGroup>
        {/* Q10 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>10. Tem histórico na família de cardiopatia ou alguma outra doença? (diabetes, hipertensão, câncer, doenças autoimune, alergias?</ControlLabel>
          <FormControl
            name="q10"
            type="text"
            componentClass="textarea"
            rows="4"
            className="textarea-fixed"
            value={this.state.q10}
            onChange={(event) => this.onInputChange(event.target)}
          />
        </FormGroup>

        {/* Q11 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>11. Quanto tempo tem disponível para treinar? Quais dias vai se comprometer a treinar? (Não vale responder todos os dias, especifique). </ControlLabel>
          <FormControl
            name="q11"
            type="text"
            componentClass="textarea"
            rows="4"
            className="textarea-fixed"
            value={this.state.q11}
            onChange={(event) => this.onInputChange(event.target)}
          />
        </FormGroup>

        {/* Q12 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>12. Horário do treino?</ControlLabel>
          <FormControl
            name="q12"
            type="text"
            componentClass="textarea"
            rows="4"
            className="textarea-fixed"
            value={this.state.q12}
            onChange={(event) => this.onInputChange(event.target)}
          />
        </FormGroup>

        {/* Q13 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>13. Horário de Dormir e Acordar?</ControlLabel>
          <FormControl
            name="q13"
            type="text"
            componentClass="textarea"
            rows="4"
            className="textarea-fixed"
            value={this.state.q13}
            onChange={(event) => this.onInputChange(event.target)}
          />
        </FormGroup>

        {/* Q14 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>14. Qual exercício mais gosta? Qual você menos gosta?</ControlLabel>
          <FormControl
            name="q14"
            type="text"
            componentClass="textarea"
            rows="4"
            className="textarea-fixed"
            value={this.state.q14}
            onChange={(event) => this.onInputChange(event.target)}
          />
        </FormGroup>

        {/* Q15 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>15. Segue alguma dieta? Caso tenha uma dieta, anexe ao questionário ou mande foto. Caso não tenha, descreva a sua rotina alimentar com detalhes (horário e alimentos) </ControlLabel>
          <FormControl
            name="q15"
            type="text"
            componentClass="textarea"
            rows="4"
            className="textarea-fixed"
            value={this.state.q15}
            onChange={(event) => this.onInputChange(event.target)}
          />
        </FormGroup>

        {/* Q16 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>16. Descanso: Você dorme rapidamente, acorda descansado, acorda durante a noite, comente.</ControlLabel>
          <FormControl
            name="q16"
            type="text"
            componentClass="textarea"
            rows="4"
            className="textarea-fixed"
            value={this.state.q16}
            onChange={(event) => this.onInputChange(event.target)}
          />
        </FormGroup>

        {/* Q17 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>17. Pico de cansaço durante o dia:</ControlLabel>
          <FormControl
            name="q17"
            type="text"
            componentClass="textarea"
            rows="4"
            className="textarea-fixed"
            value={this.state.q17}
            onChange={(event) => this.onInputChange(event.target)}
          />
        </FormGroup>

        {/* Q18 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>18. Qual a sua frequência cardíaca de repouso:</ControlLabel>
          <FormControl
            name="q18"
            type="text"
            componentClass="textarea"
            rows="4"
            className="textarea-fixed"
            value={this.state.q18}
            onChange={(event) => this.onInputChange(event.target)}
          />
        </FormGroup>
        {/* Q19 */}
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>19. Caso tenha outras observações que você considera importante e não se encaixam em nenhuma dessas perguntas, escreva aqui:</ControlLabel>
          <FormControl
            name="q19"
            type="text"
            componentClass="textarea"
            rows="4"
            className="textarea-fixed"
            value={this.state.q19}
            onChange={(event) => this.onInputChange(event.target)}
          />
        </FormGroup>

        <p>Lembre-se que todas essas perguntas são importantes para um bom acompanhamento.</p>

        {
          //verificando se é professor
          JSON.parse(localStorage.getItem("USER")).role == 'professor' ?
            null
            :
            <div>
              {
                this.state.loadUser ? <div class="loader"></div> : <Button bsStyle="warning" className="float-left" onClick={() => this.saveAnamnese()}>Salvar anamnese</Button>
              }
            </div>
        }

      </div >


    );
  }
}

export default Anamnese;



// WEBPACK FOOTER //
// src/components/alunos/user-anamnese.js